export const formValidatorTypes = {
    comproveForm: "[validator] comprove schema",
    setSchema: "[validator] setting Schema",
    setErrors: "[validator] setting Errors",
    removeError: "[validator] removing Errors",
};
